import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a1979ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "header-links gt-sm"
}

import { computed, withDefaults } from 'vue'

interface Link {
  text: string,
  href: string,
  isActive?: boolean,
}

interface Props {
  maxVisible?: number,
  links: Link[]
}


export default /*#__PURE__*/_defineComponent({
  props: {
    maxVisible: { default: 12 },
    links: null
  },
  setup(__props: any) {

const props = __props as { maxVisible: number, links: Link[] }



const showExtendedMenu = computed(() => props.maxVisible >= props.links.length)

return (_ctx: any,_cache: any) => {
  const _component_c_header_menu_link = _resolveComponent("c-header-menu-link")!
  const _component_c_menu_item = _resolveComponent("c-menu-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_c_tile_btn = _resolveComponent("c-tile-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(showExtendedMenu))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.links, (link) => {
            return (_openBlock(), _createBlock(_component_c_header_menu_link, {
              key: link.href,
              text: link.text,
              href: link.href,
              "is-active": link.isActive
            }, null, 8, ["text", "href", "is-active"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_c_tile_btn, {
      icon: "mdi-menu",
      class: _normalizeClass(_unref(showExtendedMenu) ? 'lt-md' : '')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_menu, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_list, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.links, (link) => {
                  return (_openBlock(), _createBlock(_component_c_menu_item, {
                    key: link.href,
                    text: link.text,
                    href: link.href
                  }, null, 8, ["text", "href"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"])
  ], 64))
}
}

})